export default __webpack_public_path__ + "static/media/keyvisualSKNuernberg.e84acfbc.jpg";